import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useSystemsByPropertyId(
  propertyId,
  zoneSerialNumber,
  options,
  key = "getSystemsByPropertyId",
) {
  const axiosPrivate = useAxiosPrivate();

  const getSystemsByPropertyId = async () => {
    const events = await axiosPrivate({
      method: "GET",
      url: `/Zone/GetSystemsForProperty?propertyId=${propertyId}${
        zoneSerialNumber ? `&zoneSerialNumber=${zoneSerialNumber}` : ""
      }`,
    }).then((res) => res.data);
    return events;
  };

  return useQuery(
    [key, propertyId],
    () => getSystemsByPropertyId(propertyId, zoneSerialNumber),
    {
      ...options,
    },
  );
}

export default useSystemsByPropertyId;
